import React from "react"
import PropTypes from "prop-types"
import Header from "components/header"
import Footer from "components/footer"
import {Helmet} from "react-helmet";

const Layout = ({ children }) => {
  return (
    <>
        <Helmet>
            <script src="https://stgokulabweb.blob.core.windows.net/scripts/typekit.js"></script>
        </Helmet>
      <Header />
      <div id="page-content">
        <main>{children}</main>
      </div>
      <Footer />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
